var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math) {var rand  = Math.random();
var lockSlideActive = rand > 0.3 ? 'active' : '';
var auth0SlideActive = rand <= 0.3 ? 'active' : '';




pug_html = pug_html + ((null == (pug_interp = require("./partials/new-hero.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./partials/features.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./partials/new-lock-section.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./partials/customers.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./partials/pricing-plans.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./partials/std_cert.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./partials/try.pug").call(this, locals)) ? "" : pug_interp));}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/homepage/home-page.pug
// module id = 1297
// module chunks = 0